import React from 'react';

import { Svg } from '@rbilabs/universal-components';
import { Image } from 'expo-image';
import { Path, Rect } from 'react-native-svg';

const crownPng = require('./crown.png');

export const MenuAcceleratorBadgeSvg = () => {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" style={{ width: 24, height: 24 }}>
      <Rect width={24} height={24} rx={12} fill="#FFAA00" />
      <Path
        d="M17.4983 8.97595L16.4795 9.68009L15.4608 10.3842C15.3067 10.4891 15.1269 10.5319 14.9535 10.5105C14.7802 10.4912 14.6132 10.4099 14.487 10.2729L13.5795 9.28415L12.672 8.29535C12.4923 8.09845 12.2461 8 12 8C11.7539 8 11.5077 8.09845 11.328 8.29535L10.4205 9.28415L9.51303 10.2729C9.38676 10.4099 9.21982 10.4912 9.04646 10.5105C8.8731 10.5298 8.69332 10.4891 8.53922 10.3842L7.52046 9.68009L6.50171 8.97595C6.2406 8.79617 5.9324 8.80901 5.69912 8.94813C5.46583 9.08725 5.30531 9.34835 5.33741 9.66511L5.63277 12.5972L5.92812 15.5294C5.94738 15.7199 6.03727 15.8868 6.16997 16.0067C6.30266 16.1265 6.47816 16.1993 6.67079 16.1993H12H17.3292C17.5197 16.1993 17.6973 16.1265 17.83 16.0067C17.9627 15.8868 18.0526 15.7199 18.0719 15.5294L18.3672 12.5972L18.6626 9.66511C18.6947 9.34835 18.5342 9.08725 18.3009 8.94813C18.0654 8.80901 17.7594 8.79617 17.4983 8.97595Z"
        fill="#502314"
      />
    </Svg>
  );
};

export const MenuAcceleratorBadgeBigSvg = () => (
  <Image source={crownPng} style={{ width: 40, height: 40 }} />
);

export const MenuAcceleratorCrownSvg = () => {
  return (
    <Svg width={16} height={16} viewBox="0 0 16 16" fill="none" style={{ width: 16, height: 16 }}>
      <Path
        d="M13.4983 4.97595L12.4795 5.68009L11.4608 6.38423C11.3067 6.4891 11.1269 6.53191 10.9535 6.51051C10.7802 6.49124 10.6132 6.40992 10.487 6.27294L9.5795 5.28415L8.67204 4.29535C8.49226 4.09845 8.24613 4 8 4C7.75387 4 7.50775 4.09845 7.32797 4.29535L6.4205 5.28415L5.51304 6.27294C5.38676 6.40992 5.21983 6.49124 5.04647 6.51051C4.87311 6.52977 4.69332 6.4891 4.53923 6.38423L3.52047 5.68009L2.50171 4.97595C2.2406 4.79617 1.93241 4.80901 1.69912 4.94813C1.46584 5.08725 1.30532 5.34835 1.33742 5.66511L1.63277 8.59725L1.92813 11.5294C1.94739 11.7199 2.03728 11.8868 2.16998 12.0067C2.30267 12.1265 2.47817 12.1993 2.67079 12.1993H8H13.3292C13.5197 12.1993 13.6973 12.1265 13.83 12.0067C13.9627 11.8868 14.0526 11.7199 14.0719 11.5294L14.3672 8.59725L14.6626 5.66511C14.6947 5.34835 14.5342 5.08725 14.3009 4.94813C14.0655 4.80901 13.7594 4.79617 13.4983 4.97595Z"
        fill="#FFAA00"
      />
    </Svg>
  );
};
